import { RouteConfig } from 'vue-router';

export const NAME_ROUTES_FEEDBACK = {
  FEEDBACK: 'feedkback'
};

export const Feedback: Array<RouteConfig> = [
  {
    path: '/feedkback',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_FEEDBACK.FEEDBACK,
        component: () => import(/* webpackChunkName: "feedback" */ '@/pages/Feedback/index.vue'),
        meta: { title: 'Feedback' }
      }
    ]
  }
];
